import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Chapters from "@/components/Chapters";
import Bento from "@/components/Bento";
import Pricing from "@/components/Pricing";
import LeadForm from "@/components/LeadForm";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#ffffff] text-[#171717]" data-testid="app-root">
      <Toaster position="top-center" theme="dark" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Chapters />
        <Bento />
        <Pricing />
        <LeadForm />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}

export default App;
